import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import CartSlideOver from './CartSlideOver';
import SocialProof from './SocialProof';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-bb-black">
      <Navigation />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <CartSlideOver />
      <SocialProof />
    </div>
  );
};

export default Layout;
